import { Suspense, lazy } from 'react';

import { PageLoader } from '@/shared/ui';

const OnboardingAsync = lazy(() => import('./ui/Onboarding'));

export const KybQuestionnaire = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <OnboardingAsync />
    </Suspense>
  );
};
